import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 桃子视频",
    description: "抱歉，你访问的页面不存在，请返回桃子视频首页浏览更多精彩内容。",
    keywords: "桃子视频,404,页面不存在",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-950">
      <Navbar />
      <main className="relative mx-auto flex w-full max-w-7xl flex-1 flex-col items-center justify-center px-4 py-24 text-center md:px-8">
        <h1 className="pointer-events-none select-none font-heading text-[7rem] font-black leading-none text-background-800 md:text-[12rem]">
          404
        </h1>
        <div className="relative z-10 -mt-8 md:-mt-14">
          <h2 className="text-xl font-semibold text-foreground-50 md:text-2xl">页面走丢了</h2>
          <p className="mt-2 text-sm text-foreground-400">
            没有找到页面
            <span className="ml-1 font-mono text-foreground-300">{location.pathname}</span>
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/search"
              className="whitespace-nowrap rounded-md border border-background-600 px-5 py-2.5 text-sm font-medium text-foreground-100 transition-colors hover:border-primary-500 hover:text-primary-400"
            >
              搜索视频
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}